<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-input placeholder="唯一键" class="a_input_self margin_self" v-model="queryParam.menuKey" @keyup.enter.native="fetch" />
      <a-input placeholder="权限名称" class="a_input_self margin_self" v-model="queryParam.menuName" @keyup.enter.native="fetch" />
      <a-select placeholder="请选择状态" class="a_select_self margin_self" v-model="queryParam.visible" @keyup.enter.native="fetch">
        <a-select-option value="">全部</a-select-option>
        <a-select-option value="0">显示</a-select-option>
        <a-select-option value="1">隐藏</a-select-option>
      </a-select>
      <a-button type="primary" @click="this.fetch">查询</a-button>
      <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
      <a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新建</a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table
        ref="table"
        rowKey="menuId"
        :pagination="pagination"
        :loading="loading"
        bordered
        :columns="columns"
        :dataSource="data"
        :scroll="{ x:1400,y: scroll_y }"
      >
        <span slot="menuType" slot-scope="text">
          {{ text | menuTypeFilter }}
        </span>

        <span slot="visible" slot-scope="text">
          {{ text | statusFilter }}
        </span>

        <span slot="action" slot-scope="text, record">
          <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-if="addEnable" @click="handleAdd(record.menuId + '')">新增</a>
          <a-divider type="vertical" />
          <a v-if="removeEnable" @click="delById(record.menuId)">删除</a>
        </span>
      </a-table>
    </div>

    <permission-modal ref="modal" @ok="handleOk" />
  </div>
</template>

<script>
import { Table as T } from 'ant-design-vue'
import { getPermissions, delPerm } from '@/api/system'
import PermissionModal from './modules/PermissionModal.vue'
import { treeData } from '@/utils/treeutil'
import { checkPermission } from '@/utils/permissions'
export default {
  name: 'TableList',
  components: {
    T,
    PermissionModal,
  },
  data() {
    return {
      description: '菜单管理，只有menuKey(唯一)不为空才生效',
      scroll_y: 150,
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      form: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},

      // 表头
      columns: [
        {
          title: '权限名称',
          dataIndex: 'menuName',
        },
        {
          title: '路由唯一键',
          dataIndex: 'menuKey',
        },
        {
          title: '组件',
          dataIndex: 'component',
        },
        {
          title: '排序',
          dataIndex: 'orderNum',
        },
        {
          title: '按钮类型',
          dataIndex: 'menuType',
          scopedSlots: { customRender: 'menuType' },
        },
        {
          title: '链接',
          dataIndex: 'path',
        },
        {
          title: '重定向',
          dataIndex: 'redirect',
        },
        {
          title: '权限标识',
          dataIndex: 'perms',
        },
        {
          title: '状态',
          dataIndex: 'visible',
          scopedSlots: { customRender: 'visible' },
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      data: [],
      pagination: false,
      loading: false,
      addEnable: checkPermission('system:menu:add'),
      editEnabel: checkPermission('system:menu:edit'),
      removeEnable: checkPermission('system:menu:remove'),
    }
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        1: '隐藏',
        0: '显示',
      }
      return statusMap[status]
    },
    menuTypeFilter(type) {
      const menuMap = {
        M: '目录',
        F: '按钮',
        C: '菜单',
      }
      return menuMap[type]
    },
  },
  created() {
    this.fetch()
  },
  mounted(){
    this.$nextTick(()=>{
      var max_h=$('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y=max_h-$(".ant-table-header").height();
      }, 1000);
    })
  },
  methods: {
    handleAdd(parentId) {
      this.$refs.modal.add(parentId)
    },
    handleEdit(record) {
      this.$refs.modal.edit(record)
    },
    handleOk() {
      // this.$refs.table.refresh()
      this.fetch()
      console.log('handleSaveOk')
    },
    delById(id) {
      delPerm(id).then((res) => {
        if (res.code === 200) {
          this.$message.success(`删除成功`)
          this.handleOk()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    fetch() {
      this.loading = true
      getPermissions(Object.assign(this.queryParam)).then((res) => {
        this.data = treeData(res.rows, 'menuId')
        this.loading = false
      })
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
}
</script>
